import { Tab, Tabs } from '@mui/material';
import React from 'react';


export interface TabsProps {
  onChangeTab: (event: React.SyntheticEvent, newValue: number) => void;
  value: number
}

export default function BenefitApprovalTabs({ onChangeTab, value }: TabsProps) {
  // const { } = useTabs();
  return (
    <div data-testid='tabs-render-test'>
      <Tabs onChange={onChangeTab} value={value}>
        <Tab label='Pendentes' sx={{ px: 3 }} />
        <Tab label='Aprovados' sx={{ px: 3 }} />
        <Tab label='Recusados' sx={{ px: 3 }} />
      </Tabs>
    </div>
  )
}
